import { Col, Modal, Row, Card, Image, Space, Typography } from "antd";
import React, { useState, useEffect } from "react";
import { GoogleMap } from "../../Common";
import { get, pick } from "lodash";
import { getObjectListBySuffix, getDataFromS3 } from "../../../aws-amplify";
import OneGeoMapWithMarker from "./OSMBMap";
import userServices from "../../../UserServices/UserServices";
import { getMyCensusShopCardData, getMyClientShopCardData } from "../../../Services/auth";
import { CensusShopService, ClientShopService } from "../../../Services";
import DataGrid from "./DataGrid.";
import DailyTrafficContent from "../../PolygonsModal/DailyTrafficContent";
// import { SunOutlined, CloudOutlined, MoonOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const { REACT_APP_AWS_BUCKET_URL } = process.env;
const slots = [
	{ label: "Morning", time: "8:00 AM – 11:59 AM", icon: null, color: "#FFE58F" },
	{
		label: "Afternoon",
		time: "12:00 PM – 4:59 PM",
		icon: null,
		color: "#91D5FF"
	},
	{ label: "Evening", time: "5:00 PM – 11:00 PM", icon: null, color: "#FF85C0" }
];

const tennatMappingforImages = {
	BAT_STATES: "BAT_US"
};

export const HandleMarkerClick = ({ visible, selectedMarker, setVisible }) => {
	const [loading, setLoading] = useState(false);
	// eslint-disable-next-line no-unused-vars
	const [polygonloading, setPolygonLoading] = useState(false);

	const { tenant } = pick(userServices.getCurrentUser(), ["tenant"]);
	const [images, setImages] = useState([]);
	const [popularTimes, setPopularTimes] = useState({});

	// eslint-disable-next-line no-unused-vars
	const [polygon, setPolygon] = useState([]);

	// const [osmPolygon, setOsmPolygon] = useState([]);
	// eslint-disable-next-line no-unused-vars
	const [center, setCenter] = useState(null);
	// eslint-disable-next-line no-unused-vars
	const [tableData, setTableData] = useState([]);

	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoading(true);
				const shopId = selectedMarker?.id;
				if (!shopId) return;
				const isClient = selectedMarker?.isClient;
				const dbKeys = isClient ? getMyClientShopCardData() : getMyCensusShopCardData();
				const keysToFetch = dbKeys.map(({ key }) => key);

				const serviceMethod = isClient
					? ClientShopService.getClientShopDetails
					: CensusShopService.getCensusShopDetails;

				const { data } = await serviceMethod({ shopId, keysToFetch });

				const mappedData = dbKeys.map(({ key, name }) => ({
					name,
					value: get(data, key, "N/A")
				}));

				setTableData(mappedData);
				setLoading(false);
			} catch (error) {
				console.error("Error fetching census shop details:", error);
			}
		};

		fetchData();
	}, [selectedMarker]);

	const census_id = selectedMarker?.data?.["Census ID"];

	useEffect(() => {
		setCenter(selectedMarker?.position);
		if (!census_id) return;

		const fetchImages = async () => {
			setPolygonLoading(true);
			const prefix = `public/data/${tennatMappingforImages[tenant] || tenant}/outlets/fascia/${census_id}`;
			const suffix = ".jpg";
			const allImages = await getObjectListBySuffix(prefix, suffix);

			setImages(allImages.map(image => `${REACT_APP_AWS_BUCKET_URL}${image}`));
			let polygonData = await getDataFromS3(
				`data/${tennatMappingforImages[tenant] || tenant}/outlets/building_footprints/${census_id}.json`
			);

			let coordinates = polygonData?.[0]?.coordinates;

			let popularTime = await getDataFromS3(
				`data/${tennatMappingforImages[tenant] || tenant}/outlets/popular_times/${census_id}.json`
			);

			if (popularTime) {
				setPopularTimes(popularTime);
			}
			let polygon = {
				id: "shop_marker",
				name: "shop_marker",
				_id: "shop_marker",
				center: coordinates?.[0],
				coordinates,
				type: "shop_marker",
				style: {
					fillColor: "#FF000077",
					strokeColor: "#FF000077"
				}
			};

			// const convertedPolygon = {
			// 	id: polygon.id,
			// 	coordinates: [polygon.coordinates.map(coord => [coord.lng, coord.lat])],
			// 	style: polygon.style
			// };

			setPolygon(polygon);
			// setOsmPolygon(convertedPolygon);
			setPolygonLoading(false);
		};

		fetchImages();
	}, [census_id]);

	// Effect to handle modal close and cleanup map
	useEffect(() => {
		if (!visible) {
			// Clear any residual data when modal is closed
			setImages([]);
			setPolygon([]);
			setCenter(null);
		}
	}, [visible]);

	if (!visible) return null;
	return (
		<Modal
			open={visible}
			onCancel={() => {
				const element = document.getElementById("osmb-script");
				element?.remove();
				setVisible(false);
			}}
			onOk={() => {
				const element = document.getElementById("osmb-script");
				element?.remove();
				setVisible(false);
			}}
			width={1350}
			bodyStyle={{
				padding: 0,
				borderRadius: "10px",
				overflow: "hidden"
			}}
		>
			{/* Custom Header */}
			<div
				style={{
					backgroundColor: "#33a0d5",
					padding: "10px 15px",
					color: "#fff",
					fontSize: "16px",
					fontWeight: "bold"
				}}
			>
				Outlet Details
			</div>

			<Row gutter={[12, 10]} style={{ padding: "15px" }}>
				{/* Images */}
				<Col span={12}>
					<Card
						className="shadow"
						title="Image"
						headStyle={{
							backgroundColor: "#e3f2fd",
							color: "#000",
							fontWeight: "bold",
							boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 10px"
						}}
					>
						{images.length === 0 ? (
							<Row justify="center" align="middle" style={{ height: "500px" }}>
								{" "}
								<Image
									src="https://via.placeholder.com/150"
									fallback="https://via.placeholder.com/150"
								/>
							</Row>
						) : (
							<Image.PreviewGroup>
								<div
									style={{
										height: "400px",
										maxHeight: "400px", // Set the maximum height for the scrollable container
										overflowY: "auto", // Enable vertical scrolling when content overflows
										padding: "8px", // Optional: Add padding for better aesthetics
										border: "1px solid #ddd", // Optional: Add a border to visually contain the scrollable area
										backgroundColor: "#f9f9f9" // Optional: Set a background color for better visuals
									}}
								>
									<Space direction="vertical" wrap>
										{images.map((src, index) => (
											<Image key={index} src={src} fallback="https://via.placeholder.com/150" />
										))}
									</Space>
								</div>
							</Image.PreviewGroup>
						)}
					</Card>
				</Col>
				{/* Outlet Details */}

				{/* Location */}
				<Col span={12}>
					<Card
						className="shadow"
						title="Location"
						headStyle={{
							backgroundColor: "#e3f2fd",
							color: "#000",
							fontWeight: "bold",
							boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 10px"
						}}
					>
						{center && (
							<GoogleMap
								mapHeight="400px"
								center={center}
								polygons={[polygon]}
								_markers={[selectedMarker]}
								markers={{ census_Shops: true }}
							/>
						)}
					</Card>
				</Col>
				<Col span={24}>
					<Card className="shadow">
						<DataGrid tableData={tableData} loading={loading} />
					</Card>
				</Col>
				<Col span={24}>
					{/* {!polygonloading && (
						<OneGeoMapWithMarker
							markerLocation={{ lat: 47.3764201, lng: 8.5598501 }}
							polygon={{
								center: { lat: 47.3764201, lng: 8.5598501 },
								coordinates: [
									{ lng: 8.5598501, lat: 47.3764201 },
									{ lng: 8.5597955, lat: 47.3763773 },
									{ lng: 8.5598376, lat: 47.3763538 },
									{ lng: 8.5597584, lat: 47.3762887 },
									{ lng: 8.5596217, lat: 47.376368 },
									{ lng: 8.5595476, lat: 47.3764003 },
									{ lng: 8.5595778, lat: 47.3764325 },
									{ lng: 8.5597078, lat: 47.3765025 },
									{ lng: 8.5598501, lat: 47.3764201 } // Closed loop
								]
							}}
						/>
					)} */}

					{!polygonloading && (
						<OneGeoMapWithMarker
							key={census_id}
							markerLocation={selectedMarker?.position}
							polygon={polygon}
						/>
					)}
				</Col>
				<Col span={24}>
					{popularTimes?.populartimes && (
						<Row>
							<Col span={24}>
								<Row gutter={[16, 16]} justify="space-between">
									{slots.map(({ label, time, icon, color }) => (
										<Col xs={24} sm={8} key={label}>
											<Card
												hoverable
												style={{
													textAlign: "center",
													borderRadius: 12,
													boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
													borderTop: `4px solid ${color}`
												}}
												bodyStyle={{ padding: "24px" }}
											>
												<div style={{ marginBottom: 12 }}>{icon}</div>
												<Text strong style={{ fontSize: 16, color: "#333" }}>
													{label} Time
												</Text>
												<Title level={4} style={{ margin: "12px 0 0" }}>
													{time}
												</Title>
											</Card>
										</Col>
									))}
								</Row>
							</Col>
							<Col span={24}>
								<DailyTrafficContent
									isVisible={true}
									polygon={{
										filterData: {
											popular_times: popularTimes.populartimes
										}
									}}
								/>
							</Col>
						</Row>
					)}
				</Col>
			</Row>
		</Modal>
	);
};

export default HandleMarkerClick;
